import { useUpdateCompany } from "Company/Api/Mutation/updateCompanyMutation";
import type { CompanyResponseDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { BaseCard } from "Shared/Components/Cards/BaseCard";
import type { FC } from "react";
import { CompanyForm } from "../Form/Form";

type Props = {
	company: CompanyResponseDto;
};

export const EditFormWidget: FC<Props> = ({ company }) => {
	const { mutate: updateCompany, isPending } = useUpdateCompany(
		Number(company.id),
	);
	const { t } = useResource();
	const companyResource = Resources.base.company;

	return (
		<BaseCard title={t(companyResource.shared.editCompany)}>
			<CompanyForm
				onSubmit={updateCompany}
				defaultData={company}
				isPending={isPending}
			/>
		</BaseCard>
	);
};
